import type { ProgramInviteType } from 'models';
import { useState } from 'react';
import type { FormInstance } from 'ui';
import { useDebounce } from 'common/hooks';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useProgramsUsersInfiniteQuery } from 'features/programs/queries';
import type { EmailSelectedUser, RegisteredSelectedUser } from '../../../../types';
import type { InviteesType } from '../../../EventInvitees';
import type { CommonFormValues } from './hooks';
import InviteesPicker from './InviteesPicker';

type P = {
  allowedInvites?: InviteesType[];
  form: FormInstance<CommonFormValues>;
  inviteType: ProgramInviteType;
  onBack?: () => void;
  onInvite: (
    inviteType: ProgramInviteType,
    invitees: RegisteredSelectedUser[],
    emailInvitees?: EmailSelectedUser[],
  ) => void;
  programId: string;
};

const ProgramEventInviteesPicker = ({ programId, ...rest }: P) => {
  const [search, setSearch] = useState<string>();
  const { isDebouncing, value } = useDebounce(search);
  const {
    data: programUsers,
    error: programUsersError,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingProgramUsers,
    isLoading: isLoadingProgramUsers,
    isRefetching: isRefetchingProgramUsers,
  } = useProgramsUsersInfiniteQuery({
    filter: { programId, search: value },
    pagination: { pageSize: 6 },
  });

  const allProgramUsers = programUsers?.pages.flat();

  return (
    <InviteesPicker
      {...rest}
      data={allProgramUsers}
      error={programUsersError}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetching={isFetchingProgramUsers}
      isLoading={isLoadingProgramUsers || isDebouncing}
      isRefetching={isRefetchingProgramUsers}
      onSearch={setSearch}
    />
  );
};

export default ProgramEventInviteesPicker;
